import Storage from './index';
const tokenStorage = new Storage('app.authToken');
export default tokenStorage;
